import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
    static values = {
        url: String
    }

    connect() {
    }

    filter(event) {
        // Create URL with the mailing_type parameter
        const url = new URL(this.urlValue)
        url.searchParams.set("mailing_type", event.target.value)

        // Preserve other query parameters from current URL
        const currentUrl = new URL(window.location)
        currentUrl.searchParams.forEach((value, key) => {
            // Skip mailing_type as we're setting it explicitly
            if (key !== "mailing_type") {
                url.searchParams.set(key, value)
            }
        })

        // Make a Turbo Stream visit request
        fetch(url.toString(), {
            headers: {
                "Accept": "text/vnd.turbo-stream.html",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(response => response.text())
            .then(html => {
                Turbo.renderStreamMessage(html)
            })

    }
}